export default __webpack_public_path__ + "static/media/tete67.59cdb776.png";